<template>
  <div>
    <emd-card>
      <emd-card-header>
        <emd-text size="section">
          {{ $t('keys.api-data') }}
        </emd-text>
      </emd-card-header>

      <emd-card-content>
        <alert-test-account :show="isTestAccount" />
        <version />
        <account-id />
        <public-key />
      </emd-card-content>
    </emd-card>

    <secret-keys />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  EmdText,
  EmdCard,
  EmdCardHeader,
  EmdCardContent
} from 'emerald-vue/src/components'

export default {
  components: {
    EmdText,
    EmdCard,
    EmdCardHeader,
    EmdCardContent,

    AlertTestAccount: () => import('./AlertTestAccount.vue'),
    Version: () => import('./Version.vue'),
    AccountId: () => import('./AccountId.vue'),
    PublicKey: () => import('./PublicKey.vue'),
    SecretKeys: () => import('./SecretKeys.vue')
  },

  computed: {
    ...mapGetters(['isTestAccount'])
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "keys": {
      "api-data": "Dados da API"
    }
  },
  "en-US": {
    "keys": {
      "api-data": "API Data"
    }
  }
}
</i18n>
